module.exports = __webpack_public_path__ + "img/Echo_with_baby.eba572c2.jpg";